import React from 'react';

/**
 * Bloc informations salarié
 */
export function EmployeeBlock({ employee }) {
  if (!employee) return null;

  return (
    <div className="payroll-employee-block">
      <div className="payroll-employee-row">
        <div className="payroll-employee-col">
          <div className="payroll-detail-line">
            <span className="payroll-label">Nom et prénom :</span>
            <span className="payroll-value">{employee.last_name} {employee.first_name}</span>
          </div>
          {employee.nir_last4 && (
            <div className="payroll-detail-line">
              <span className="payroll-label">NIR :</span>
              <span className="payroll-value">**** **** *** {employee.nir_last4}</span>
            </div>
          )}
          <div className="payroll-detail-line">
            <span className="payroll-label">Emploi :</span>
            <span className="payroll-value">
              {employee.job_title || 'Non spécifié'}
              {employee.contract_type === 'APPRENTI' && (
                <span className="payroll-apprentice-badge">Apprenti(e)</span>
              )}
            </span>
          </div>
        </div>
        <div className="payroll-employee-col">
          {employee.classification_level && (
            <div className="payroll-detail-line">
              <span className="payroll-label">Classification :</span>
              <span className="payroll-value">
                {employee.classification_level}
                {employee.classification_echelon && ` - ${employee.classification_echelon}`}
              </span>
            </div>
          )}
          {employee.classification_coefficient && (
            <div className="payroll-detail-line">
              <span className="payroll-label">Coefficient :</span>
              <span className="payroll-value">{employee.classification_coefficient}</span>
            </div>
          )}
          <div className="payroll-detail-line">
            <span className="payroll-label">Statut :</span>
            <span className="payroll-value">
              {employee.status_cadre === 'CADRE' ? 'Cadre' : 'Non-cadre'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
